import React from "react"

import Layout2 from "../components/layout2"
import SEO from "../components/seo"
import InternLinks from "../components/internlinks";
import { FaCheck } from 'react-icons/fa';
import { Breadcrumb } from "../components/globals/breadcrumb";

const IndexPage = () => (
  <Layout2>
    <Breadcrumb category={["recensioner", "recensioner"]} page={["Simplesmile", "simplesmile"]}/>
     <SEO title="Simplesmile® " description="Recension av Simplesmile® "/>
     <section className="section-produkter">
       <article>
       <div className="prod-text">
          <h1>Vita tänder med Simplesmile® </h1>
         </div>
      </article>
      <article class="right">
        <img src="../simplesmile.jpg" alt="Simplesmile® Tandblekning"/>
        <aside>
          <h2>599:-</h2>
          <h3>Expertkit</h3>
          <p>Simplesmile® Expert Kit är vårt mest effektiva kit för maximalt resultat av din tandblekning. 100% peroxidfri och skonsam mot tänder och tandkött.</p>
          <a href="https://click.adrecord.com?c=36553&p=1117&url=https%3A//simplesmile.com/sv/produkt/teeth-whitening-x4-expert-kit/" target="_blank" rel="noopener noreferrer" class="btn btn-warning btn-width">Beställ här</a>
          <ul>
             <li><FaCheck className="li-icon" /> 100% peroxidfri</li>
             <li><FaCheck className="li-icon" /> Inga ilningar </li>
          </ul>
        </aside>
        <div className="prod-text"><h5>Om produkten</h5>
         <p>Expert Kit är ett komplett tandblekningskit för att effektivt bleka tänderna hemma snabbt, enkelt och skonsamt. Den innehåller Triple Boost Max tandblekningsgel, 
             som används tillsammans med de medföljande munskenorna som utformas individuellt med hjälp av varmt vatten.</p>
            <p>Förpackningen innehåller: </p>
            <ul class="ben-list">
              <li>3 x formbara munskenor</li> 
              <li>Expert Kit tandblekningsgel (10 ml)</li> 
              <li>Applikator och bruksanvisning</li> 
            </ul>
          </div>
       </article>
       <article>
        <img src="../simplepen.jpg" alt="Simplesmile® tandblekningspenna"/> 
        <aside>
          <h3>340:-</h3>
          <h2>Expert Pen</h2>
          <p>Simplesmile® Tandblekning Expert Pen med vår mest effektiva tandblekningsgel erbjuder ett smidigt och enkelt sätt att underhålla tändernas vithet som ett komplement till Simplesmile® kompletta tandblekningskit.
          </p>
          <a href="https://click.adrecord.com?c=36553&p=1117&url=https%3A//simplesmile.com/sv/produkt/teeth-whitening-x4-expert-pen/" target="_blank" rel="noopener noreferrer" class="btn btn-warning btn-width">Beställ här</a>
          <ul>
             <li><FaCheck className="li-icon" /> Smidig och enkel</li>
             <li><FaCheck className="li-icon" /> Snabbt resultat</li>
             <li><FaCheck className="li-icon" /> ca 20 behandlingar</li>
          </ul>

        </aside>
        <div className="prod-text"><h5>Om produkten</h5>
        <p>Den effektiva blekgelen penslas direkt på tänderna och tack vare den fina penseln blir blekgelen jämnt fördelat. Blekgelen torkar efter ca 30 sekunder och blekningen påbörjas omgående. En behandling tar omkring 15 minuter och du kan lätt upprepa behandlingen tills du uppnått önskat resultat. En tandblekningspenna räcker till ca 20 behandlingar och passar perfekt för dig som snabbt önskar få vitare tänder innan festen eller dejten.</p></div>
      </article>
            <article>
        <img src="../simplefoam.jpg" alt="Simplesmile® Dual Foam"/> 
        <aside>
          <h3>449:-</h3>
          <h2>Dual Foam</h2>
          <p>Simplesmile® Dual Foam är ett tandblekningsskum som används som en vanlig tandkräm. Ett perfekt alternativ för dig som inte vill eller kan hantera tandblekning med hjälp av tandblekningsgel och munskenor.
          </p>
          <a href="https://click.adrecord.com?c=36553&p=1117&url=https%3A//simplesmile.com/sv/produkt/simplesmile-dual-foam/" target="_blank" rel="noopener noreferrer" class="btn btn-warning btn-width">Beställ här</a>
          <ul>
             <li><FaCheck className="li-icon" /> Smidig och enkel</li>
             <li><FaCheck className="li-icon" /> Snabbt resultat</li>
             <li><FaCheck className="li-icon" /> ca 20 behandlingar</li>
          </ul>

        </aside>
        <div className="prod-text"><h5>Om produkten</h5>
        <p>Simplesmile® Dual Foam tandblekning är ett tandblekningsskum som används som en tandkräm. Under behandlingen 
            ersätter Dual Foam din vanliga tandkräm. Behandlingen består av två steg som både rengör och bleker tänderna 
            och är ett perfekt alternativ för dig som inte vill eller kan hantera tandblekning med hjälp av tandblekningsgel 
            och munskenor. Borsta tänderna som vanligt med Dual Foam i 3 minuter både morgon och kväll.</p>
                        <p>Förpackningen innehåller: </p>
            <ul class="ben-list">
              <li>1 x Cleaning Foam (50 ml)</li> 
              <li>1 x Whitening Foam (50 ml)</li> 
              <li>Nyansguide samt bruksanvisning.</li> 
            </ul>
            </div>
                  

      </article>

       </section>
       {/* <section className="section-cards">
    <main>
    <h2 class="rubrik-tandblekning">Bästa tandblekningen hemma</h2>
       <Card />
    </main>
  </section> */}


  <section className="section-cards card-height">
  <main>
      <h2 class="internal-rubrik">Bästa tandblekningen hemma</h2>
    <InternLinks />
    </main>
  </section>
  </Layout2>
)

export default IndexPage
